import { type VariantProps, cva } from 'class-variance-authority';
import type { ComponentProps } from 'react';

import { cn } from '@/design-system/lib/cn';

/**
 * Pílula genérica. Quando comunica estado, leva ícone + texto — o tom sozinho nunca
 * carrega significado.
 */
const badgeVariants = cva(
  [
    'inline-flex w-fit shrink-0 items-center gap-1.5 rounded-pill font-medium whitespace-nowrap',
    '[&_svg]:size-3 [&_svg]:shrink-0 [&_svg]:stroke-2',
  ],
  {
    variants: {
      tone: {
        neutral: 'bg-surface-muted text-ink-secondary',
        primary: 'bg-primary-soft text-primary-hover',
        published: 'bg-status-published-bg text-status-published',
        complete: 'bg-status-complete-bg text-status-complete',
        partial: 'bg-status-partial-bg text-status-partial',
        conflict: 'bg-status-conflict-bg text-status-conflict',
        awaiting: 'bg-status-awaiting-bg text-status-awaiting',
      },
      size: {
        md: 'h-6 px-2.5 text-caption',
        sm: 'h-5.5 px-2 text-caption',
      },
    },
    defaultVariants: { tone: 'neutral', size: 'md' },
  }
);

export type BadgeProps = ComponentProps<'span'> & VariantProps<typeof badgeVariants>;

export function Badge({ className, tone, size, ...props }: BadgeProps) {
  return <span data-slot="badge" className={cn(badgeVariants({ tone, size }), className)} {...props} />;
}

export { badgeVariants };
